// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2013":"e185a1fb","2561":"e185a1fb","7155":"e185a1fb","9536":"e185a1fb"}[chunkId] + ".chunk.css";
};